import { Component, OnInit, Input, OnChanges, ViewChild, AfterViewInit} from '@angular/core';
import * as Chart from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
@Component({
  selector: 'app-size-sales',
  templateUrl: './size-sales.component.html',
  styleUrls: ['./size-sales.component.css']
})
export class SizeSalesComponent implements OnInit,AfterViewInit, OnChanges {

  @ViewChild(BaseChartDirective, {static: true}) chart: BaseChartDirective;
  @Input() userSizeSales: any;
  @Input() userKSP: any;
  sizeSales: any[] = [];
  dataGraf: number[] = [];
  year: number[] = [];
  maxVolume: number;
  selectedIndex: number = 0;
  currentYear: number = 0;

  constructor() { }

  public barChartData = [
    {data: this.dataGraf, label: 'Объем продаж в месяце'},
  ];
  public barChartOptions = {
    responsive: true,
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        font: {
          size: 12,
          family: 'Gerbera',
        },
        formatter: function(value) {
          return Math.round(value).toLocaleString();
        }
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            display:false
          },
          beforeBuildTicks: function(context){
            context.max
          },
          gridLines: {
            display: false,
            drawBorder: false,
        }
        }
      ],
      xAxes: [
        {
          ticks:{
            fontFamily: 'Gerbera',
          },
          gridLines:{
            display: false
          }
        }
      ]
    }
  };
  public barChartPlugins = [pluginDataLabels];
  public barChartLabels = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
  public barChartType = 'bar';
  public barChartLegend = false;
  public barChartColors = [
    {
      backgroundColor: 'rgb(219, 227, 136)'
    }
  ];
  ngOnInit() {}

  ngAfterViewInit(){}

  activateClass(year){
    year.active = !year.active;    
  }

  ngOnChanges() {
    if(this.userSizeSales.sales != undefined){
      this.sizeSales = this.userSizeSales.sales;
      let oldYear = null;
      this.currentYear = new Date().getFullYear();
      for(let item of this.sizeSales) {
        if(item.year != oldYear){
          oldYear = item.year;
          this.year.push(item.year);
        }
        if(item.year == this.currentYear){
          if(item.volume != undefined){
            this.dataGraf.push(Math.round(item.volume / 1000)).toLocaleString();
          }
          else{
            this.dataGraf.push(Math.round(0));
          }
          
        }
        
      }
      this.year.reverse();
      for(let year of this.year){
        if(year == this.currentYear){
          this.selectedIndex = this.year.indexOf(year);
        } else{
          this.selectedIndex = null
        }
      }
      this.dataGraf.reverse();
      this.barChartOptions = {
        responsive: true,
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            font: {
              size: 12,
              family: 'Gerbera'
            },
            formatter: function(value) {
              return Math.round(value).toLocaleString();
            }
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                display:false
              },
              beforeBuildTicks: function(context){
                if(context.max <= 250){
                  return context.max = context.max + 100
                }
                if(context.max <= 500 && context.max > 250){
                  return context.max = context.max + 200
                }
                if(context.max <=1000 && context.max > 500){
                  return context.max = context.max + 500
                }
                if(context.max <= 2500 && context.max > 1000){
                  return context.max = context.max + 1000
                }                 
                if(context.max <= 5000 && context.max > 2500){
                  return context.max = context.max + 2000
                }
              },
              gridLines: {
                display: false,
                drawBorder: false,
            }
            }
          ],
          xAxes: [
            {
              ticks:{
                fontFamily: 'Gerbera',
              },
              gridLines:{
                display: false
              }
            }
          ]
        }
      }
      this.chart.chart.update();
    }
  }

  onClickChangeYear(event:any, index: number){
    event.preventDefault();
    this.selectedIndex = index;
    this.dataGraf = [];
    //this.sizeSales = [];
    this.chart.chart.update();
    var yearSelected = event.target.innerText;
    if(this.userSizeSales.sales != undefined){
      this.sizeSales = this.userSizeSales.sales;
      //this.sizeSales.reverse();
      for(let item of this.sizeSales) {
        if(item.year == yearSelected){
          if(item.volume != undefined){
            this.dataGraf.push(Math.round(item.volume / 1000));
          }
          else{
            this.dataGraf.push(Math.round(0));
          }
        } 
        
      }
      this.dataGraf.reverse();
      this.barChartData = [
        {data: this.dataGraf, label: 'Объем продаж в месяце'},
      ];
      this.chart.chart.update();
      
      return true;
    }
  }
}
